"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const veflux_1 = require("vasat/dist/src/veflux");
class KeyEvent extends veflux_1.BaseSimpleEvent {
}
exports.KeyEvent = KeyEvent;
class KeyboardService {
    constructor() {
        this._keysPressed = new veflux_1.ArrayStore(KeyEvent).setEqualOperator((a, b) => a.keyCode == b.keyCode);
        this._subs = [];
        this.keyDown = (e) => {
            this._keysPressed.add(e);
        };
        this.keyUp = (e) => {
            this._keysPressed.remove(e);
        };
        document.addEventListener('keydown', this.keyDown);
        document.addEventListener('keyup', this.keyUp);
        this._subs.push(this._keysPressed.events.subscribe(ev => {
            if (ev.event == 'ADD') {
                if (ev.item.key == 'Shift')
                    this._isShift = true;
                else if (ev.item.key == 'Control' || ev.item.key == 'Meta')
                    this._isCtrl = true;
            }
            else if (ev.event == 'REMOVE') {
                if (ev.item.key == 'Shift')
                    this._isShift = false;
                else if (ev.item.key == 'Control' || ev.item.key == 'Meta')
                    this._isCtrl = false;
            }
        }));
    }
    ngDestroy() {
        document.removeEventListener('keyup', this.keyUp);
        document.removeEventListener('keydown', this.keyDown);
    }
    get keysPressed() {
        return this._keysPressed;
    }
    get isShift() {
        return this._isShift;
    }
    get isCtrl() {
        return this._isCtrl;
    }
}
exports.KeyboardService = KeyboardService;
